"use client";

import { Instagram, Music2, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
const playbookLinks = [{
  label: "ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ",
  to: "https://hoteldeals.gr/%cf%83%cf%85%cf%87%ce%bd%ce%ad%cf%82-%ce%b5%cf%81%cf%89%cf%84%ce%ae%cf%83%ce%b5%ce%b9%cf%82-faq/"
}, {
  label: "ΝΕΕΣ ΚΡΑΤΗΣΕΙΣ",
  to: "https://hoteldeals.vlmtravel.com/#/welcome"
}, {
  label: "ΠΟΛΙΤΙΚΗ ΑΚΥΡΩΣΗ",
  to: "https://hoteldeals.gr/%cf%80%ce%bf%ce%bb%ce%b9%cf%84%ce%b9%ce%ba%ce%ae-%ce%b1%ce%ba%cf%85%cf%81%cf%8e%cf%83%ce%b5%cf%89%ce%bd/"
}];
const socialLinks = [{
  Icon: Instagram,
  label: "Instagram",
  to: "https://www.instagram.com/hoteldealsgr/"
}, {
  Icon: Music2,
  label: "TikTok",
  to: "#"
}, {
  Icon: Facebook,
  label: "Facebook",
  to: "#"
}];
const legalLinks = [{
  label: "ΠΡΟΣΩΠΙΚΑ ΔΕΔΟΜΕΝΑ",
  to: "https://hoteldeals.gr/%cf%80%ce%bf%ce%bb%ce%b9%cf%84%ce%b9%ce%ba%ce%ae-%ce%b1%cf%80%ce%bf%cf%81%cf%81%ce%ae%cf%84%ce%bf%cf%85-%cf%80%cf%81%ce%bf%cf%83%cf%89%cf%80%ce%b9%ce%ba%ce%ac-%ce%b4%ce%b5%ce%b4%ce%bf%ce%bc%ce%ad/"
}, {
  label: "ΟΡΟΙ ΧΡΗΣΗΣ",
  to: "https://hoteldeals.gr/%cf%8c%cf%81%ce%bf%ce%b9-%cf%87%cf%81%ce%ae%cf%83%ce%b7%cf%82/"
}, {
  label: "ΠΡΟΣΒΑΣΙΜΟΤΗΤΑ",
  to: "https://hoteldeals.gr/%ce%b4%ce%ae%ce%bb%cf%89%cf%83%ce%b7-%cf%80%cf%81%ce%bf%cf%83%ce%b2%ce%b1%cf%83%ce%b9%ce%bc%cf%8c%cf%84%ce%b7%cf%84%ce%b1%cf%82/"
}];
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="1274" id="εταιρικές-πληροφορίες" className="relative bg-background text-foreground overflow-hidden border-t border-border" style={{
    clipPath: "none"
  }}>
      <div className="absolute top-0 left-0 w-2 h-2 bg-primary z-10" style={{
      transform: "translate(0, 2vw)"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative pt-32 pb-12 px-6 md:px-12 lg:px-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="flex items-center gap-3 mb-12 max-w-[1400px] mx-auto">
          <div className="w-6 h-px bg-primary" />
          <span className="font-mono text-xs tracking-[0.2em] text-muted-foreground">
            INDEX 04 
          </span>
        </div>

        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 pb-16">
          <div className="md:col-span-4 flex flex-col gap-5">
            <Link to="/" aria-label="HotelDeals.gr home">
              <WvcLogo className="h-[48px] w-auto" />
            </Link>
            <p className="font-default text-lg md:text-xl text-foreground/80 leading-relaxed max-w-sm">
              Η πλατφορμα με τις καλύτερες τιμές ξενοδοχείων για όλο το κόσμο
            </p>
          </div>

          <div className="md:col-span-4 grid grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <h4 className="font-default text-sm tracking-[0.2em] text-muted-foreground">
                ΕΤΑΙΡΕΙΑ
              </h4>
              <p className="font-default text-base text-foreground/90 leading-relaxed">
                VLM TRAVEL ΠΑΡΟΧΗ ΤΟΥΡΙΣΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ ΙΚΕ
              </p>
            </div>
            <div className="flex flex-col gap-4">
              <h4 className="font-default text-sm tracking-[0.2em] text-muted-foreground">
                ΟΔΗΓΟΣ
              </h4>
              <ul className="flex flex-col gap-3">
                {playbookLinks.map((item, i) => <li data-index={i} key={item.label}>
                    <Link to={item.to} target={i === 1 ? "_blank" : undefined} rel={i === 1 ? "noopener noreferrer" : undefined} className="font-default text-base uppercase tracking-widest text-foreground hover:text-primary transition-colors duration-200">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="md:col-span-2 flex flex-col gap-4">
            <h4 className="font-default text-sm tracking-[0.2em] text-muted-foreground">
              ΕΠΙΚΟΙΝΩΝΙΑ
            </h4>
            <div className="flex flex-col gap-2 font-default text-sm text-foreground/90">
              <Link to="mailto:reservations@hoteldeals.gr" className="hover:text-primary transition-colors break-all">
                reservations@hoteldeals.gr
              </Link>
              <Link to="tel:+302111829790" className="hover:text-primary transition-colors">
                Tel: 2111829790
              </Link>
              <div className="transition-colors">
                Viber/Whatsapp: 6970504708
              </div>
            </div>
          </div>

          <div className="md:col-span-2 flex flex-col gap-4">
            <h4 className="font-default text-sm tracking-[0.2em] text-muted-foreground">
              SOCIAL
            </h4>
            <div className="flex gap-3 flex-wrap">
              {socialLinks.map((item, i) => {
              const Icon = item.Icon;
              return <Link data-index={i} key={item.label} to={item.to} target={i === 0 ? "_blank" : undefined} rel={i === 0 ? "noopener noreferrer" : undefined} aria-label={item.label} className="w-10 h-10 border border-border flex items-center justify-center text-foreground hover:bg-primary hover:border-primary hover:text-primary-foreground transition-all duration-200">
                    <Icon className="w-4 h-4" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <div className="max-w-[1400px] mx-auto pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 border-t border-border">
          <span className="font-mono text-xs tracking-[0.15em] uppercase text-muted-foreground">
            © 2025 HOTELDEALS.GR | POWERED BY VLM TRAVEL
          </span>
          <ul className="flex flex-wrap gap-6">
            {legalLinks.map((item, i) => <li data-index={i} key={item.label}>
                <Link to={item.to} target={i === 1 || i === 2 ? "_blank" : undefined} rel={i === 1 || i === 2 ? "noopener noreferrer" : undefined} className="font-mono text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-primary transition-colors">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}